import Route from "@ember/routing/route";
import { service } from "@ember/service";
import type BloodPressureSessionStartedJournalEvent from "parog-web/models/blood-pressure-session-started-journal-event";
import type Patient from "parog-web/models/patient";
import type FetcherService from "parog-web/services/fetcher";
import type NavigationService from "parog-web/services/navigation";
import { sortBy } from "parog-web/utils/sort";

export default class BloodPressureSessionsRoute extends Route {
  @service declare fetcher: FetcherService;
  @service declare navigation: NavigationService;

  override async model(): Promise<BloodPressureSessionStartedJournalEvent[]> {
    const patient = this.modelFor(
      `${this.navigation.currentPatientRouteName}`
    ) as Patient;

    await this.fetcher.loadRecords(
      "blood-pressure-session-started-journal-event",
      {
        filter: { patient_id: patient.id },
        include: "blood-pressure-measured-journal-events"
      }
    );

    const activeBloodPressureSessions =
      patient.bloodPressureSessionStartedJournalEvents;

    return activeBloodPressureSessions
      ? activeBloodPressureSessions
          .filter(session => !session.isDeleted)
          .sort(sortBy("occurredAt", "desc"))
      : [];
  }
}
